import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class ClaimSetHistoryVisitsServerStorageUpdatedEvent extends EventV2<object> {}
